import dayjs from "dayjs";

export const JOB_OPPORTUNITY_STATUSES = {
  ACTIVE: "ACTIVE",
  CANCELLED: "CANCELLED",
  FULFILLED: "FULFILLED",
  RDFULFILLED: "RDFULFILLED",
  DELETED: "DELETED",
  DRAFT: "DRAFT",
  PENDINGAPPROVAL: "PENDINGAPPROVAL",
};

export const JOB_OPPORTUNITY_TIME_COMMITMENT = {
  FULLTIME: "FULLTIME",
  PARTTIME: "PARTTIME",
};

export const SOCIAL_LINK_TYPES = {
  BADGR: "BADGR",
  CALENDAR: "CALENDAR",
  DEV: "DEV",
  FACEBOOK: "FACEBOOK",
  GITHUB: "GITHUB",
  HASHNODE: "HASHNODE",
  INSTAGRAM: "INSTAGRAM",
  LINKEDIN: "LINKEDIN",
  PORTFOLIO: "PORTFOLIO",
  STACKOVERFLOW: "STACKOVERFLOW",
  TWITTER: "TWITTER",
};

export const CUSTOM_LINK_TYPES = {
  CHAIN: "CHAIN",
  EXTERNALLINK: "EXTERNALLINK",
  GENERAL: "GENERAL",
  RESULT: "RESULT",
  RESUME: "RESUME",
  OTHER: "OTHER",
};

export const JOB_APPLICATION_MATCH_STATUS_FORMATTED = {
  ACCEPTED: "Accepted",
  APPLIED: "Applied",
  MATCHED: "Matched",
  PASSEDON: "Passed On",
  PRESHORTLISTED: "Pre-Candidate",
  REJECTEDBYCUSTOMER: "Rejected (Customer)",
  REJECTEDBYMATCHER: "Rejected (Matcher)",
  REJECTEDBYMEMBER: "Rejected (Member)",
  SHORTLISTED: "Shortlisted",
  TKSHORTLISTED: "Pre-Candidate",
  MOREINFO: "More Info",
  OFFERSENT: "Offer Sent",
  INTERESTED: "Interested",
  INTERESTEDFASTTRACK: "Interested Fasttrack",
};

export const JOB_APPLICATION_MATCH_STATUS = {
  ACCEPTED: "ACCEPTED",
  APPLIED: "APPLIED",
  MATCHED: "MATCHED",
  PASSEDON: "PASSEDON",
  REJECTEDBYCUSTOMER: "REJECTEDBYCUSTOMER",
  REJECTEDBYMATCHER: "REJECTEDBYMATCHER",
  REJECTEDBYMEMBER: "REJECTEDBYMEMBER",
  SHORTLISTED: "SHORTLISTED",
  PRESHORTLISTED: "PRESHORTLISTED",
  TKSHORTLISTED: "TKSHORTLISTED",
  MOREINFO: "MOREINFO",
  SKIPPED: "SKIPPED",
  DELETED: "DELETED",
  OFFERSENT: "OFFERSENT",
  INTERESTED: "INTERESTED",
  INTERESTEDFASTTRACK: "INTERESTEDFASTTRACK",
};

export const JOB_APPLICATION_MATCH_SUB_STATUS = {
  FINALIST: "FINALIST",
  NULL: null,
};
export const JOB_APPLICATION_MATCH_SUB_STATUS_FORMATTED = {
  FINALIST: "Only Finalists",
};

export const MATCH_RATING_REASONS_FORMATTED = {
  RATE: "Rate",
  LOCATION: "Location",
  TIMEZONE: "Timezone",
  INSUFFICIENTSKILLS: "Insufficient Skills",
  INSUFFICIENTEXPERIENCE: "Insufficient Experience",
  EXPERIENCENOTRELEVANT: "Experience Not Relevant",
};

export const CUSTOM_LINK_TITLES_BY_TYPE = {
  [CUSTOM_LINK_TYPES.EXTERNALLINK]: "External link",
  [CUSTOM_LINK_TYPES.GENERAL]: "General link",
  [CUSTOM_LINK_TYPES.OTHER]: "Other link",
  [CUSTOM_LINK_TYPES.RESULT]: "Result link",
  [CUSTOM_LINK_TYPES.RESUME]: "Resume link",
};

export const USER_TYPES = {
  FREELANCER: "FREELANCER",
  CUSTOMER: "CUSTOMER",
};

export const CUSTOM_PANEL_DEFAULT_OPERATOR = {
  TKSkillsHierarchy: "and",
  "intelProfessions.name": "and",
  "educationRecords.degreeType": "and",
  "knownLanguages.language": "and",
  "assessments.testName": "and",
};

export const USER_STATUS = {
  ACTIVE: "ACTIVE",
  ARCHIVED: "ARCHIVED",
  INACTIVE: "INACTIVE",
  SUSPENDED: "SUSPENDED",
};

export const DEFAULT_RATE_RANGE = { min: 0, max: 200 };
export const DEFAULT_SALARY_RANGE = { min: 0, max: 416000 };

export const GEOGRAPHICAL_REGIONS = [
  {
    regionName: "North America",
    countryNames: ["United States", "Canada", "Mexico"],
  },
  {
    regionName: "Asia",
    countryNames: ["India", "China", "Japan"],
  },
  {
    regionName: "Europe",
    countryNames: ["France", "Germany", "Italy"],
  },
];

export const APPLICATION_TAB_NAMES = {
  PRECANDIDATES: "Pre-Candidates",
  SEARCHRESULTS: "Search Results",
  MATCHED: "Matched",
  SHORTLISTED: "Shortlisted",
  LONGLISTED: "Web Applies",
  SKIPPED: "Skipped",
  IDEAL: "Ideal Fit",
};

export const SEARCH_BY_ATTRIBUTES = [
  {
    title: "Default",
    attributes: [
      "bio",
      "careers.description",
      "careers.stack",
      "careers.title",
      "careers.TKSkills.name",
      "company",
      "email",
      "externalUserId",
      "family_name",
      "fullName",
      "given_name",
      "id",
      "identity_username",
      "knownLanguages_str",
      "location",
      "parsedResume.content",
      "projectsCaseStudies.description",
      "projectsCaseStudies.stack",
      "projectsCaseStudies.title",
      "referralCode",
      "referrerCode",
      "resumeWorkHistory.description",
      "resumeWorkHistory.stack",
      "resumeWorkHistory.title",
      "tagline",
      "TKSkillsHierarchy",
      "username",
    ],
  },
];

export const NOTE_TYPES = {
  GENERAL: "GENERAL",
  JOBFEEDBACK: "JOBFEEDBACK",
};

export const NOTE_TYPES_MAPPED_ICON = {
  JOBFEEDBACK: { icon: "jobFeedback", label: "Job Feedback" },
  BULLHORN: { icon: "bullhorn", label: "Bullhorn" },
};

export const LANGUAGE_KEY_NAMES = {
  language: "knownLanguages.language",
  level: "knownLanguages.level",
};

// Not multiplying by 1000 since the field was stored as Int
export const ENGAGEMENT_STATUS_RANGE_DATES_ITEMS = [
  {
    label: "Free (Currently Not Engaged)",
    start: null, // There is some custom filtering for this field connector needs a defined value
  },
  {
    label: "Not Free (Currently Engaged)",
    start: dayjs().startOf("day").unix(),
  },
  {
    label: "Engagement Ending < 2 weeks",
    start: dayjs().startOf("day").unix(),
    end: dayjs().add(2, "week").endOf("day").unix(),
  },
  {
    label: "Engagement Ending < 4 weeks",
    start: dayjs().startOf("day").unix(),
    end: dayjs().add(4, "week").endOf("day").unix(),
  },
];

export const PLACEMENT_FILTERS = {
  notHasActivePlacements: " AND (NOT hasActivePlacements:true)",
};

// Not multiplying by 1000 since the field was stored as Int
export const PREVIOUS_ENGAGEMENT_RANGE_DATES_ITEMS = [
  {
    label: "Previously Placed",
    end: dayjs().startOf("day").unix(),
  },
];

export const LOCATION_FILTER_ACTIONS = {
  ADD: "ADD",
  REMOVE: "REMOVE",
};

export const MEMBER_REJECTION_REASONS = {
  LACKEXPERIENCE: "Do not have required technology skill level",
  STACKNOTDESIRED: "Prefer to work in other technology stacks",
  LOCATIONNOTFEASIBLE: "Unable to work required time zone",
  NOTAVAILABLE: "Not available for new jobs",
  RATELOW: "Rate is too low",
  OTHER: "Other",
};

export const MATCH_REJECTION_TEXT = {
  ENGLISHLANGDEFICIT: "Poor verbal or written English language skills",
  INADEQUATESKILLLVL: "Inadequate skill level",
  LACKEXPERIENCE: "Lack of relevant experience",
  LACKKNOWLEDGE: "Unable to clearly explain concepts or approaches",
  LOCATIONNOTFEASIBLE: "Location or time zone overlap is not a fit",
  MISSINGSKILL: "Missing one or more required skills",
  OTHER: "Other",
  RATEHIGH: "Rate is too high",
};

export const EDUCATION_DEGREE_TYPES = {
  ASSOCIATES_OR_EQUIVALENT: "ASSOCIATES_OR_EQUIVALENT",
  BACHELORS_OR_EQUIVALENT: "BACHELORS_OR_EQUIVALENT",
  MASTERS_OR_EQUIVALENT: "MASTERS_OR_EQUIVALENT",
  DOCTORAL_OR_EQUIVALENT: "DOCTORAL_OR_EQUIVALENT",
  UPPER_SECONDARY_EDUCATION: "UPPER_SECONDARY_EDUCATION",
  DEGREE_TYPE_UNSPECIFIED: "DEGREE_TYPE_UNSPECIFIED",
};

export const EDUCATION_DEGREE_TYPES_TEXT = {
  ASSOCIATES_OR_EQUIVALENT: "Associates",
  BACHELORS_OR_EQUIVALENT: "Bachelors",
  MASTERS_OR_EQUIVALENT: "Masters",
  DOCTORAL_OR_EQUIVALENT: "PhD",
  UPPER_SECONDARY_EDUCATION: "High School",
  DEGREE_TYPE_UNSPECIFIED: "Unspecified",
};

export const REJECTION_REASONS = [
  {
    title: MATCH_REJECTION_TEXT.ENGLISHLANGDEFICIT,
    value: "ENGLISHLANGDEFICIT",
  },
  {
    title: MATCH_REJECTION_TEXT.INADEQUATESKILLLVL,
    value: "INADEQUATESKILLLVL",
  },
  {
    title: MATCH_REJECTION_TEXT.LACKEXPERIENCE,
    value: "LACKEXPERIENCE",
  },
  {
    title: MATCH_REJECTION_TEXT.LACKKNOWLEDGE,
    value: "LACKKNOWLEDGE",
  },
  {
    title: MATCH_REJECTION_TEXT.LOCATIONNOTFEASIBLE,
    value: "LOCATIONNOTFEASIBLE",
  },
  {
    title: MATCH_REJECTION_TEXT.MISSINGSKILL,
    value: "MISSINGSKILL",
  },
  {
    title: MATCH_REJECTION_TEXT.OTHER,
    value: "OTHER",
  },
  {
    title: MATCH_REJECTION_TEXT.RATEHIGH,
    value: "RATEHIGH",
  },
];

export const PROJECT_CASE_STUDY_WORK_TYPES_TEXT = {
  PROJECT: "Project",
  CASESTUDY: "Case Study",
};

export const JOB_TYPES_TEXT = {
  FULLTIME: "Full Time",
  PARTTIME: "Part Time",
  SELFEMPLOYED: "Self employed",
  CONTRACT: "Contract",
};

export const IDEAL_FIT_SEARCH_TYPES = {
  ADVANCED: "Advanced",
  BASIC: "Basic",
};

export const EMPLOYMENT_TYPES = {
  CONTRACT: "Contract",
  DTCPERMPLACEMENT: "DTC Permanent Placement",
  DTCSOLUTION: "DTC Solutions Position",
  PERMPLACEMENT: "Permanent Placement",
  CONTRACTTOPERM: "Contract to Permanent Placement",
  SOLUTION: "Solutions Position",
  IC: "Independent Contractor (IC)",
};

export const BULLHORN_METADATA_FORMATTED = {
  LOB: "Line of Business",
  "Date Available": "Date Available",
  "Contact Name": "Contact Name",
  "Job Description": "Job Description",
  "RITS Candidates Allowed": "RiTS Candidates Allowed",
  "Vendors Allowed": "3rd Party Vendors Allowed",
  "Internal Notes": "Notes",
  IsOpen: "Is Open",
};

export const USER_LIST_VIEWS = {
  MATCH_AGENT: "Match Agent",
  FULL_PROFILE: "Full Profile",
  LIST: "List View",
};

export const REFERRER_SOURCE = {
  RECRUITERRESUME: "RECRUITERRESUME",
};

export const CURRENCY_CONVERSION_CONFIG = {
  ...JSON.parse(process.env.REACT_APP_CURRENCY_CONVERSION || "{}"),
};

export const YEARS_OF_EXPERIENCE_CONFIG = {
  ...JSON.parse(process.env.REACT_APP_YEARS_OF_EXPERIENCE_CONFIG || "{}"),
};

export const YEARS_OF_EXPERIENCE_FILTER_STR_TEMPLATE =
  " AND (overallExperience >= {!value})";

export const YEARS_OF_EXPERIENCE_CONFIG_IS_ENABLED =
  YEARS_OF_EXPERIENCE_CONFIG.locationCountryNames?.length > 0;

export const GEOGRAPHICAL_REGIONS_CONFIG = process.env
  .REACT_APP_GEOGRAPHICAL_REGIONS
  ? JSON.parse(process.env.REACT_APP_GEOGRAPHICAL_REGIONS)
  : GEOGRAPHICAL_REGIONS;

export const DEFAULT_BH_STATUSES_TO_EXCLUDE = JSON.parse(
  process.env.REACT_APP_DEFAULT_BH_STATUSES_TO_EXCLUDE || "[]"
);

export const ROLE_SEARCH_CONFIG = JSON.parse(
  process.env.REACT_APP_ROLE_SEARCH_CONFIG || "{}"
);

export const ROWS_PER_PAGE_ON_PAGINATED_TABLE = parseInt(
  process.env.REACT_APP_APPLICATION_HITS_PER_PAGE || 50
);

export const SKILL_TYPES = {
  REQUIRED: "required",
  OPTIONAL: "optional",
};

export const MATCH_TAB_STATUSES = [
  { status: JOB_APPLICATION_MATCH_STATUS.ACCEPTED },
  { status: JOB_APPLICATION_MATCH_STATUS.APPLIED },
  { status: JOB_APPLICATION_MATCH_STATUS.MATCHED },
  { status: JOB_APPLICATION_MATCH_STATUS.OFFERSENT },
  { status: JOB_APPLICATION_MATCH_STATUS.PASSEDON },
  { status: JOB_APPLICATION_MATCH_STATUS.REJECTEDBYCUSTOMER },
  { status: JOB_APPLICATION_MATCH_STATUS.REJECTEDBYMATCHER },
  { status: JOB_APPLICATION_MATCH_STATUS.REJECTEDBYMEMBER },
  { status: JOB_APPLICATION_MATCH_STATUS.MOREINFO },
];

export const SHORTLISTED_TAB_STATUSES = [
  { status: JOB_APPLICATION_MATCH_STATUS.SHORTLISTED },
  { status: JOB_APPLICATION_MATCH_STATUS.INTERESTED },
  { status: JOB_APPLICATION_MATCH_STATUS.INTERESTEDFASTTRACK },
];

export const PRE_CANDIDATES_TAB_STATUSES = [
  { status: JOB_APPLICATION_MATCH_STATUS.PRESHORTLISTED },
  { status: JOB_APPLICATION_MATCH_STATUS.TKSHORTLISTED },
];

export const SKIPPED_TAB_STATUSES = [
  { status: JOB_APPLICATION_MATCH_STATUS.SKIPPED },
];

export const SEARCH_SOURCE = {
  OPEN_SEARCH: "OPEN_SEARCH",
};

export const TK_SKILL_CATEGORY_MAP = {
  CERTIFICATION: "Certifications",
  IT: "IT (Tech)",
  LANGUAGE: "Languages",
  PROFESSIONAL: "Professional",
  SOFT: "Soft Skills",
};

export const TK_CATEGORY_UI_SORT_ORDER = [
  "IT",
  "PROFESSIONAL",
  "CERTIFICATION",
  "LANGUAGE",
  "SOFT",
];

export const LOADING_STATES = {
  LOADING: "LOADING",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",
  IDLE: "IDLE",
};

export const EXPERIENCE_LEVELS = [
  { value: "low", label: "0-2" },
  { value: "medium", label: "2-5" },
  { value: "high", label: "5+" },
];

export const POST_GOOGLE_AUTH_REDIRECT = "Torc_postGoogleAuthRedirect";

export const SEARCH_AGENT_MESSAGES = [
  "Analyzing core responsibilities and requirements",
  "Extracting key skills and technologies from the job details",
  "Decoding internal notes for hidden client priorities",
  "Identifying alternative job titles to broaden the search",
  "Considering analogous industries with similar challenges",
  "Cross-referencing requirements for pattern repetition",
  "Screening for potentially mismatched or misleading skills",
  "Detecting required certifications mentioned in the text",
  "Weighing the strategic importance of each keyword",
  "Constructing the final, prioritized search query",
];

export const MATCH_AGENT_MESSAGES = [
  "Mapping the candidate's professional career timeline",
  "Aligning professional history with role expectations",
  "Evaluating career progression and role-to-role velocity",
  "Assessing the depth and tenure in relevant positions",
  "Looking beyond job titles to understand true responsibilities",
  "Identifying key strengths that align with the target role",
  "Pinpointing potential experience gaps in the career path",
  "Giving greater weight to the most recent, relevant experience",
  "Checking for non-traditional paths that demonstrate capability",
  "Synthesizing analysis into a final match assessment",
];

export const COMMUNITY_BOOST_LEVELS = {
  HIGH: "HIGH",
  MEDIUM: "MEDIUM",
  LOW: "LOW",
  NONE: "NONE",
};
